/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum IntakesAndOutputsRetroactiveJustificationAliases {
  FIELD_INTAKES_RETROACTIVE_JUSTIFICATION = 'field-intakes-retroactive-justification',
  FORM_INTAKES_RETROACTIVE_JUSTIFICATION = 'form-intakes-retroactive-justification',
  LAYOUT_INTAKES_RETROACTIVE_JUSTIFICATION = 'layout-intakes-retroactive-justification',
  PANEL_INTAKES_RETROACTIVE_JUSTIFICATION = 'panel-intakes-retroactive-justification',
  TEXT_AREA_INTAKES_RETROACTIVE_JUSTIFICATION = 'text-area-intakes-retroactive-justification',
}
export { IntakesAndOutputsRetroactiveJustificationAliases };
